import React,{ FormEvent, useState } from "react";
import { useAppDispatch  } from "../../hooks/redux";
import { searchBaseContent } from "../../actions/videoInput";
import { Button, Form, FormGroup, Search } from "semantic-ui-react";

interface BaseContentPageProps {
    handleSearch: () => void;
    handleTyping: (t: string) => void;
    searchText: string | undefined;
}

export default function SearchField({handleSearch, handleTyping,searchText}: BaseContentPageProps) {

  const onChange = (s:any)=> {
    handleTyping(s?.target?.value)
  }

  const onSubmit = (e:FormEvent<HTMLFormElement>) => {
    handleSearch();
  }

  return (
    <div>
          <Form onSubmit={onSubmit}>
            <FormGroup>
              <Search
                loading={false}
                placeholder='Zoeken...'
                onSearchChange={onChange}
                open={false}
                value={searchText}
              />
            <Button type='submit'>Zoek</Button>
          </FormGroup>
        </Form>
    </div>
  );
}
